module.exports = "/desktop-app/assets/img/bars.png?476a2f72d002f8160f5306bb7f256d9c";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/bars.png
// module id = O2nk
// module chunks = 1